import api from '@/api'

const { $practica} = api;

export const { $professionalizingPractices } = $practica;